import React from 'react';

import { ButtonPrimary } from '../../StyledComponent';
import MessagePopUp from '../../MessagePopup';

const AditivoAssinadoSucesso = ({ handleSuccess, tema }) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <MessagePopUp
        title={'Aditivo assinado com sucesso'}
        message={
          'Pode demorar alguns minutos para que as parcelas sejam liberadas. Por favor, retorne ao financeiro e atualize a página.'
        }
        txtAlign={'center'}
      >
        <ButtonPrimary onClick={handleSuccess} tema={tema} width={'396'}>
          RETORNAR AO FINANCEIRO
        </ButtonPrimary>
      </MessagePopUp>
    </div>
  );
};

export default AditivoAssinadoSucesso;
